import React from "react";

const FooterContact = () => {
  return (
    <div className="footerContact">
      <h4>Contact gegevens</h4>
      <li>Treubstraat 130</li>
      <li>2221AR Katwijk</li>
      <li>Telefoon: +31 6 23 21 35 66</li>
      <li>KVK-nummer: 89407628</li>
      <li>e-mail: info@bzco.nl</li>
    </div>
  );
};

export default FooterContact;
